/** Read only an explicit tenant entry; an absent or malformed entry reserves nothing. */
export const getMantraNavigationHeight = (
	serializedConfig: string,
	cloudId: string,
	extensions: ReadonlyArray<{ id?: string }>,
): number => {
	if (!extensions.some((extension) => extension.id?.endsWith('/mantra-navigation'))) {
		return 0;
	}

	return getConfiguredMantraNavigationHeight(serializedConfig, cloudId);
};

export const getConfiguredMantraNavigationHeight = (
	serializedConfig: string,
	cloudId: string,
): number => {
	try {
		const config: unknown = JSON.parse(serializedConfig);
		if (!config || typeof config !== 'object' || Array.isArray(config)) {
			return 0;
		}
		const height = Object.prototype.hasOwnProperty.call(config, cloudId)
			? (config as Record<string, unknown>)[cloudId]
			: undefined;
		return typeof height === 'number' && Number.isFinite(height) && height > 0 && height <= 200
			? height
			: 0;
	} catch {
		return 0;
	}
};
